module.exports = __webpack_public_path__ + "img/DefaultR.2c3c9270.png";